import ScreenWrapper from "@/components/ScreenWrapper"
import CreateTeachingMaterialForm from "@/pages/lesmaterialen/aanmaken/CreateTeachingMaterialForm"
import { checkPermissions } from "@/utils/checkPermissions"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/beheer/lesmaterialen/aanmaken/")({
  component: RouteComponent,
  beforeLoad: () => checkPermissions("create", "teachingMaterials"),
})

function RouteComponent() {
  return (
    <ScreenWrapper showManagementMenu>
      <CreateTeachingMaterialForm />
    </ScreenWrapper>
  )
}
